import { Dialog } from '@mui/material';

import { ModalProps } from './Modal.interface';

export const Modal = (props: ModalProps) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth={props.maxWidth ?? false}
      fullWidth={props.fullWidth ?? false}
      fullScreen={!!props.fullScreen}>
      {props.children}
    </Dialog>
  );
};
